import './patientInformationViewComponent.scss'
import React from 'react';
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from '@mui/icons-material/Edit';
import {CommonService} from "../../../../../shared/services";
import commonService from "../../../../../shared/services/common.service";

interface PatientInformationViewComponentProps {
    patientDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const PatientInformationViewComponent = (props: PatientInformationViewComponentProps) => {
        const {patientDetails, onEditModeOpen, canEdit} = props;

        return (

            <div className="patient-information-component details-tab-data-content">
                {patientDetails && <>
                    <div className="details-tab-data-header">
                        <div className="view-and-edit-title">Personal Details</div>
                        {canEdit &&
                            <div className={'edit-action-button'}>
                                <ButtonComponent
                                    className={"white-space-nowrap"}
                                    type="button"
                                    color={"primary"}
                                    variant={"outlined"}
                                    startIcon={<EditIcon/>}
                                    fullWidth={true}
                                    handleClick={onEditModeOpen}
                                >
                                    Edit Details
                                </ButtonComponent>
                            </div>
                        }
                    </div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Prefix"}> {patientDetails?.prefix || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"First Name"}> {commonService.capitalizeFirstLetterOfEachWord( patientDetails?.firstName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Last Name"}> {commonService.capitalizeFirstLetterOfEachWord(patientDetails?.lastName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Gender"}> {patientDetails?.gender || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Race"}> {patientDetails?.race || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Height (in feet)"}> {patientDetails?.heightInFeet ? `${patientDetails?.heightInFeet} feet` : 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Suffix"}> {patientDetails?.suffix || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Middle Name"}> {commonService.capitalizeFirstLetterOfEachWord(patientDetails?.middleName) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Date of Birth"}> {commonService.formatDate(patientDetails?.dateOfBirth) || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Ethnicity"}> {patientDetails?.ethnicity || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Weight (in lbs)"}> {patientDetails?.weight || 'N/A'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Height (in inches)"}> {patientDetails?.heightInInches ? `${patientDetails?.heightInInches} inches` : 'N/A'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>

                        <div className="horizontal-line"/>
                        <div className="view-and-edit-title">Contact Details</div>
                        <div className="details-tab-data-body">
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {patientDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Business Email ID"}> {patientDetails?.businessEmailId || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Mobile Number"}> {CommonService.getMaskedMobileNumber(patientDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Business Mobile Number"}> {CommonService.getMaskedMobileNumber(patientDetails?.businessMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Secondary Mobile Number"}> {CommonService.getMaskedMobileNumber(patientDetails?.secondaryMobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>

                            </Grid>
                        </div>
                        <div className="horizontal-line"/>
                        <div className="view-and-edit-title">Address Details</div>
                        <div className="details-tab-data-body">
                            <DetailsDataKeyValueComponent
                                title={"Address Line 1"}> {patientDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Address Line 2"}> {patientDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"State"}> {patientDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"City"}> {patientDetails?.city || 'N/A'} </DetailsDataKeyValueComponent> 
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"ZIP Code"}> {patientDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"County"}> {patientDetails?.county || 'N/A'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Country"}> {patientDetails?.country || 'N/A'} </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </>
                }
            </div>
        )
    }

;

export default PatientInformationViewComponent;
